import { createGlobalStyle } from 'styled-components';
import { normalize } from './normalize';
import { typography } from './typography';
import { elements } from './elements';
import { components } from './components';
export * from './background';
export * from './background-field';
export * from './background-field-styles';
export * from './blockquote';
export * from './breakpoints';
export * from './colors';
export * from './containerWidths';
export * from './form';
export * from './gradients';
export * from './orderedLists';
export * from './radius';
export * from './shadow';
export * from './spacing';
export * from './tables';
export * from './textSize';
export * from './z-index';
export const GlobalStyles = createGlobalStyle `
  ${normalize}
  ${typography}
  ${elements}
  ${components}
`;
//# sourceMappingURL=index.js.map